import React from 'react';
import { Link } from 'react-router-dom';
import one from "../../assests/1.jpg";
import Two from "../../assests/2.jpg";
import Three from "../../assests/3.jpg";
import Four from "../../assests/4.jpg";
import Five from "../../assests/5.jpg";
import Six from "../../assests/6.jpg";
import Seven from "../../assests/7.jpg";
import Eight from "../../assests/8.jpg";
import Nine from "../../assests/9.jpg";
import Ten from "../../assests/10.jpg";
import Eleven from "../../assests/11.jpg";
import Twelve from "../../assests/12.jpg";
import Thirteen from "../../assests/13.jpg";
import Fourteen from "../../assests/14.jpg";
import Fifteen from "../../assests/15.jpg";
import Sixteen from "../../assests/16.jpg";
import Seventeen from "../../assests/17.jpg";
import Eightteen from "../../assests/18.jpg";
import Ninteen from "../../assests/19.jpg";
import Twenty from "../../assests/20.jpg";
import Twentyone from "../../assests/21.jpg";
import Twentytwo from "../../assests/22.jpg";
import Twentythree from "../../assests/23.jpg";
import TwentyFour from "../../assests/24.jpg";
import TwentyFive from "../../assests/25.jpg";
import TwentySix from "../../assests/26.jpg";
import TwentySeven from "../../assests/27.jpg";
import TwentyEight from "../../assests/28.jpg";
import TwentyNine from "../../assests/29.jpg";
import Thirty from "../../assests/30.jpg";
import Thirtyone from "../../assests/31.jpg";
import Thirtytwo from "../../assests/32.jpg";
import Thirtythree from "../../assests/33.jpg";
import ThirtyFour from "../../assests/34.jpg";
import ThirtyFive from "../../assests/35.jpg";
import ThirtySix from "../../assests/36.jpg";
import ThirtySeven from "../../assests/37.jpg";
import ThirtyEight from "../../assests/38.jpg";
import ThirtyNine from "../../assests/39.jpg";
import Fourty from "../../assests/40.jpg";
import Fourtyone from "../../assests/41.jpg";
import FourtyTwo from "../../assests/42.jpg";
import FourtyThree from "../../assests/43.jpg";
import FourtyFour from "../../assests/44.jpg";
import FourtyFive from "../../assests/45.jpg";
import FourtySix from "../../assests/46.jpg";
import FourtySeven from "../../assests/47.jpg";
import FourtyEight from "../../assests/48.jpg";
import FourtyNine from "../../assests/49.jpg";
import Fifty from "../../assests/50.jpg";
import Fiftyone from "../../assests/51.jpg";
import FiftyoneTwo from "../../assests/52.jpg";
import FiftyoneThree from "../../assests/53.jpg";
import FiftyoneFour from "../../assests/54.jpg";
import FiftyFive from "../../assests/55.jpg";
import FiftySix from "../../assests/56.jpg";
import FiftySeven from "../../assests/57.jpg";
import FiftyEight from "../../assests/58.jpg";
import FiftyNine from "../../assests/59.jpg";
import Sixty from "../../assests/60.jpg";
import Sixtyone from "../../assests/61.jpg";
import Sixtytwo from "../../assests/62.jpg";
import Sixtythree from "../../assests/63.jpg";
import SixtyFour from "../../assests/64.jpg";
import SixtyFive from "../../assests/65.jpg";
import SixtySix from "../../assests/66.jpg";
import SixtySeven from "../../assests/67.jpg";
import SixtyEight from "../../assests/68.jpg";
import SixtyNine from "../../assests/111.jpg";
import Seventy from "../../assests/70.jpg";
import Seventyone from "../../assests/71.jpg";
import Seventytwo from "../../assests/72.jpg";
import SeventyThree from "../../assests/73.jpg";
import SeventyFour from "../../assests/74.jpg";
import SeventyFive from "../../assests/75.jpg";
import SeventySix from "../../assests/76.jpg";
import SeventySeven from "../../assests/77.jpg";
import SeventyEight from "../../assests/78.jpg";
import SeventyNine from "../../assests/79.jpg";
import Eighty from "../../assests/80.jpg";
import Eightyone from "../../assests/81.jpg";
import EightyTwo from "../../assests/82.jpg";
import EightyThree from "../../assests/83.jpg";
import EightyFour from "../../assests/84.jpg";
import EightyFive from "../../assests/85.jpg";
import EightySix from "../../assests/86.jpg";
import EightySeven from "../../assests/87.jpg";
import EightyEight from "../../assests/88.jpg";
import EightyNine from "../../assests/89.jpg";
import Ninty from "../../assests/90.jpg";
import Nintyone from "../../assests/91.jpg";
import Nintytwo from "../../assests/92.jpg";
import Nintythree from "../../assests/93.jpg";
import NintyFour from "../../assests/94.jpg";
import NintyFive from "../../assests/95.jpg";
import NintySix from "../../assests/96.jpg";
import NintySeven from "../../assests/97.jpg";
import NintyEight from "../../assests/98.jpg";
import NintyNine from "../../assests/99.jpg";
import Hundred from "../../assests/100.jpg";
import Hundredone from "../../assests/101.jpg";
import Hundredtwo from "../../assests/102.jpg";
import Hundredthree from "../../assests/103.jpg";
import Hundredfour from "../../assests/104.jpg";
import HundredFive from "../../assests/105.jpg";
import HundredSix from "../../assests/106.jpg";
import HundredSeven from "../../assests/107.jpg";
import HundredEight from "../../assests/108.jpg";
import HundredNine from "../../assests/109.jpg";
import HundredTen from "../../assests/110.jpg";

function Gallery() {
  const gallerySections = [
    {
      title: "Training Nationals",
      images: [
        one, Two, Three, Four, Five, Six, Seven, Eight, Nine, Ten,
        Eleven, Twelve, Thirteen, Fourteen, Fifteen, Sixteen, Seventeen, Eightteen, Ninteen, Twenty,
        Twentyone, Twentytwo, Twentythree, TwentyFour, TwentyFive, TwentySix, TwentySeven, TwentyEight, TwentyNine, Thirty,
        Thirtyone, Thirtytwo,
      ],
    },
    {
      title: "Planting Churches",
      images: [
        Thirtythree, ThirtyFour, ThirtyFive, ThirtySix, ThirtySeven, ThirtyEight, ThirtyNine, Fourty,
        Fourtyone, FourtyTwo, FourtyThree, FourtyFour, FourtyFive,
      ],
    },
    {
      title: "Educating Children",
      images: [
        FourtySix, FourtySeven, FourtyEight, FourtyNine, Fifty, Fiftyone, FiftyoneTwo, FiftyoneThree,
        FiftyoneFour, FiftyFive, FiftySix, FiftySeven, FiftyEight, FiftyNine, Sixty, Sixtyone,
        Sixtytwo, Sixtythree, SixtyFour, SixtyFive, SixtySix, SixtySeven, SixtyEight, SixtyNine,
        Seventy, Seventyone, Seventytwo, SeventyThree, SeventyFour, SeventyFive, SeventySix, SeventySeven, SeventyEight,
      ],
    },
    {
      title: "Providing Humanitarian Aid",
      images: [
        SeventyNine, Eighty, Eightyone, EightyTwo, EightyThree, EightyFour, EightyFive, EightySix,
        EightySeven, EightyEight, EightyNine, Ninty,
      ],
    },
    {
      title: "Banquet",
      images: [
        Nintyone, Nintytwo, Nintythree, NintyFour, NintyFive, NintySix, NintySeven, NintyEight, NintyNine,
      ],
    },
    {
      title: "Vision Teams",
      images: [
        Hundred, Hundredone, Hundredtwo, Hundredthree, Hundredfour, HundredFive, HundredSix, HundredSeven,
        HundredEight, HundredNine, HundredTen,
      ],
    },
  ];

  return (
    <div
      style={{
        fontFamily: "'Georgia','Times New Roman',serif",
        background: "#fff",
        color: "#222",
      }}
    >
      <div
        style={{
          maxWidth: "930px",
          margin: "0 auto",
          padding: "0 1.5rem 4rem",
        }}
      >
        {/* Back */}
        <Link
          to="/"
          style={{
            fontSize: "13px",
            color: "#c47a1e",
            textDecoration: "none",
            display: "inline-block",
            margin: "1.5rem 0 0",
            userSelect: "none",
          }}
        >
          ← Back to Home
        </Link>

        {/* Heading */}
        <h1
          style={{
            fontFamily: "'Dancing Script','Brush Script MT',cursive",
            fontSize: "2.5rem",
            color: "#f68a3a",
            margin: "1rem 0 0.2rem",
            fontWeight: 700,
          }}
        >
          Photo Gallery
        </h1>

        {/* Orange dots */}
        <div
          style={{
            display: "flex",
            gap: "4px",
            marginBottom: "2.5rem",
          }}
        >
          {[...Array(9)].map((_, i) => (
            <div
              key={i}
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: "#f68a3a",
              }}
            />
          ))}
        </div>

        {gallerySections.map((section) => (
          <div
            key={section.title}
            style={{
              marginBottom: "4rem",
            }}
          >
            <h3
              style={{
                fontSize: "22px",
                marginBottom: "1.5rem",
                color: "#333",
                fontWeight: 500,
              }}
            >
              {section.title}
            </h3>

            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fill,minmax(95px,1fr))",
                gap: "14px",
              }}
            >
              {section.images.map((img, index) => (
                <div
                  key={index}
                  style={{
                    overflow: "hidden",
                    border: "1px solid #e5e5e5",
                    background: "#fff",
                  }}
                >
                  <img
                    src={img}
                    alt={`${section.title}-${index}`}
                    style={{
                      width: "100%",
                      height: "95px",
                      objectFit: "cover",
                      display: "block",
                      cursor: "pointer",
                      transition: ".3s",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.transform = "scale(1.08)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Gallery;
